import Comm from "services/Comm"
import Uri from "services/Uri"
import Catch401 from "middlewares/Catch401"

const GetColumnList = async function ({ type }) {

  let result = {}
  let error = {
    code: 0,
    message: ""
  }

  await Comm.request({
    url: Uri.importsGetColumns(),
    method: "post",
    data: {
      csv_type: type
    }
  }).then((res) => {
    result.data = res.data
  }).catch(Catch401((err) => {
    // console.dir(err)
    error.code = err.response.status
    error.message = err.response.data.message
  }, error))

  if (error.code) {
    return Promise.reject(error)
  }

  return Promise.resolve(result)
}

export default GetColumnList
